

// ATTACHMENT_ANALYSIS Getby Id
const ATTACHMENT_ANALYSIS_REQUEST_GETBYID = 'ATTACHMENT_ANALYSIS_REQUEST_GETBYID';
const ATTACHMENT_ANALYSIS_SUCCESS_GETBYID = 'ATTACHMENT_ANALYSIS_SUCCESS_GETBYID';
const ATTACHMENT_ANALYSIS_FAILURE_GETBYID = 'ATTACHMENT_ANALYSIS_FAILURE_GETBYID';

// ATTACHMENT_ANALYSIS Getby Id ALL
const ATTACHMENT_ANALYSIS_REQUEST_GETBYALL = 'ATTACHMENT_ANALYSIS_REQUEST_GETBYALL';
const ATTACHMENT_ANALYSIS_SUCCESS_GETBYALL = 'ATTACHMENT_ANALYSIS_SUCCESS_GETBYALL';
const ATTACHMENT_ANALYSIS_FAILURE_GETBYALL = 'ATTACHMENT_ANALYSIS_FAILURE_GETBYALL';

//ATTACHMENT_ANALYSIS Update
const ATTACHMENT_ANALYSIS_REQUEST_UPDATE = 'ATTACHMENT_ANALYSIS_REQUEST_UPDATE';
const ATTACHMENT_ANALYSIS_SUCCESS_UPDATE = 'ATTACHMENT_ANALYSIS_SUCCESS_UPDATE';
const ATTACHMENT_ANALYSIS_FAILURE_UPDATE = 'ATTACHMENT_ANALYSIS_FAILURE_UPDATE';

//ATTACHMENT_ANALYSIS ADD
const ATTACHMENT_ANALYSIS_REQUEST_ADD = 'ATTACHMENT_ANALYSIS_REQUEST_ADD';
const ATTACHMENT_ANALYSIS_SUCCESS_ADD = 'ATTACHMENT_ANALYSIS_SUCCESS_ADD';
const ATTACHMENT_ANALYSIS_FAILURE_ADD = 'ATTACHMENT_ANALYSIS_FAILURE_ADD';

//ATTACHMENT_ANALYSIS DELETE

const ATTACHMENT_ANALYSIS_REQUEST_DELETE = 'ATTACHMENT_ANALYSIS_REQUEST_DELETE';
const ATTACHMENT_ANALYSIS_SUCCESS_DELETE = 'ATTACHMENT_ANALYSIS_SUCCESS_DELETE';
const ATTACHMENT_ANALYSIS_FAILURE_DELETE = 'ATTACHMENT_ANALYSIS_FAILURE_DELETE';

export {
    ATTACHMENT_ANALYSIS_REQUEST_GETBYID, ATTACHMENT_ANALYSIS_SUCCESS_GETBYID, ATTACHMENT_ANALYSIS_FAILURE_GETBYID,
    ATTACHMENT_ANALYSIS_REQUEST_GETBYALL, ATTACHMENT_ANALYSIS_SUCCESS_GETBYALL, ATTACHMENT_ANALYSIS_FAILURE_GETBYALL,
    ATTACHMENT_ANALYSIS_REQUEST_UPDATE, ATTACHMENT_ANALYSIS_SUCCESS_UPDATE, ATTACHMENT_ANALYSIS_FAILURE_UPDATE,
    ATTACHMENT_ANALYSIS_REQUEST_ADD, ATTACHMENT_ANALYSIS_SUCCESS_ADD, ATTACHMENT_ANALYSIS_FAILURE_ADD,
    ATTACHMENT_ANALYSIS_REQUEST_DELETE, ATTACHMENT_ANALYSIS_SUCCESS_DELETE, ATTACHMENT_ANALYSIS_FAILURE_DELETE,
    // ATTACHMENT_ANALYSIS_PREV_ID
};